<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-2/3 lg:w-1/2">
			
      <component :is="currentComponent" :mitra="mitra" :category="$route.query.ft" ></component>
				
		</div>
	</section>
</template>
<script>
export default {
  components: {
    Zakat: () => import('./components/Zakat.vue'),
    Infaq: () => import('./components/Infaq.vue'),
    ZakatFitrah: () => import('./components/ZakatFitrah.vue')
  },
  data: () => ({
    currentComponent: null,
    mitra: []
  }),
  created() {
    if(!this.$route.query.t) {
      this.$router.push('/home')
    }

    this.checkVerifyAccount()

    // get opz sahabat
    this.$vs.loading()
    const params = {
      status: 1,
      status_lembaga: 1
    }

    if( !['zakat', 'infaq'].includes(this.$route.query.t) ) {
      params.zakat = this.$route.query.ft
    }

    this.$store.dispatch('mitra/getChoiceMitra', params)
    .then(data => {
      this.$vs.loading.close()
      const mitra = data.data.slice()
      mitra.map(item => item.label = item.user ? item.user.name : item.name)
      this.mitra = mitra
      // Determine type form
      const componentName = this.$route.query.t.split('_').map(it => this.capitalize(it)).join('')
      this.currentComponent = componentName
    })
    .catch(e => {
      this.$vs.loading.close()
      this.showError(e)
    })
  }
}
</script>